/* eslint-disable no-restricted-globals */
import { DateTime } from 'luxon';

export const getChartColors = yearOptions => {
  const colors = {
    2023: 'rgb(78, 29, 138)',
    2022: 'rgb(177, 72, 191)',
    2021: 'rgb(111, 222, 9)',
    2020: '#001A3C',
    2019: '#F5A623',
    2018: '#FFD45C',
    2017: '#00ADE6',
    2016: '#0087FF',
    2015: '#00B085',
    2014: '#CC0000',
    2013: 'rgb(148, 0, 211)',
    2012: 'rgb(75, 0, 130)',
    2011: 'rgb(250, 0, 0)',
    2010: 'rgb(70, 163, 191)',
    2009: 'rgb(148, 13, 11)',
    2008: 'rgb(88, 39, 201)',
    2007: 'rgb(10, 209, 141)',
    2006: 'black',
  };
  return yearOptions.reduce((dict, year) => {
    // eslint-disable-next-line no-param-reassign
    dict[year] = colors[year];
    return dict;
  }, {});
};

export const getYOYYearOptions = (ptoDate, today, zone) => {
  const endYear = parseInt(DateTime.fromISO(today, { zone }).toFormat('yyyy'), 10);
  const startYear = parseInt(DateTime.fromISO(ptoDate, { zone }).startOf('year').toFormat('yyyy'), 10);
  return new Array(endYear - startYear + 1)
    .fill(null)
    .map((_, i) => (i + startYear).toString())
    .reverse();
};

const extractConsumptionValue = node => {
  if (node && !isNaN(node.estimatedConsumptionKwh)) {
    return Number(node.estimatedConsumptionKwh);
  }
  if (node && !isNaN(node.consumptionKwh)) {
    return Number(node.consumptionKwh);
  }
  return 0;
};

const extractDeliveredKwh = node => {
  if (node && !isNaN(node.deliveredKwh)) {
    return Number(node.deliveredKwh);
  }
  return 0;
};

export const aggregateFifteenMinuteDataToHour = site => {
  const readings = {};
  const { tzName } = site;
  site.siteProductionFifteenMinute.edges.forEach(edge => {
    const { readingEndTimeLocal } = edge.node;
    const readingDate = DateTime.fromISO(readingEndTimeLocal, { zone: tzName });
    const endOfHourISO = readingDate.endOf('hour').toISO();
    const consumptionKwh = extractConsumptionValue(edge.node);
    const deliveredKwh = extractDeliveredKwh(edge.node);

    if (endOfHourISO in readings) {
      readings[endOfHourISO] = {
        ...readings[endOfHourISO],
        deliveredKwh: readings[endOfHourISO].deliveredKwh + deliveredKwh,
        consumptionKwh: readings[endOfHourISO].consumptionKwh + consumptionKwh,
        estimatedConsumptionKwh: readings[endOfHourISO].estimatedConsumptionKwh + consumptionKwh,
      };
    } else {
      readings[endOfHourISO] = {
        readingEndTimeLocal: endOfHourISO,
        deliveredKwh,
        consumptionKwh,
        estimatedConsumptionKwh: consumptionKwh,
      };
    }
  });
  return Object.keys(readings).map(dateISO => readings[dateISO]);
};

export const aggregateFifteenMinuteDataToThirty = site => {
  const readings = {};
  const { tzName } = site;
  site.siteProductionFifteenMinute.edges.forEach(edge => {
    const { readingEndTimeLocal } = edge.node;
    const readingDate = DateTime.fromISO(readingEndTimeLocal, { zone: tzName });
    const hourMidpoint = DateTime.fromISO(readingEndTimeLocal, { zone: tzName }).startOf('hour').plus({ minute: 30 });
    const endOfHourISO = readingDate.endOf('hour').toISO();
    const endOfHalfHourISO = readingDate.endOf('hour').minus({ minute: 30 }).toISO();
    const consumptionKwh = extractConsumptionValue(edge.node);
    const deliveredKwh = extractDeliveredKwh(edge.node);
    if (readingDate > hourMidpoint && endOfHourISO in readings) {
      readings[endOfHourISO] = {
        ...readings[endOfHourISO],
        deliveredKwh: readings[endOfHourISO].deliveredKwh + deliveredKwh,
        consumptionKwh: readings[endOfHourISO].consumptionKwh + consumptionKwh,
        estimatedConsumptionKwh: readings[endOfHourISO].estimatedConsumptionKwh + consumptionKwh,
      };
    } else if (readingDate > hourMidpoint) {
      readings[endOfHourISO] = {
        readingEndTimeLocal: endOfHourISO,
        deliveredKwh,
        consumptionKwh,
        estimatedConsumptionKwh: consumptionKwh,
      };
    } else if (readingDate <= hourMidpoint && endOfHalfHourISO in readings) {
      readings[endOfHalfHourISO] = {
        ...readings[endOfHalfHourISO],
        deliveredKwh: readings[endOfHalfHourISO].deliveredKwh + deliveredKwh,
        consumptionKwh: readings[endOfHalfHourISO].consumptionKwh + consumptionKwh,
        estimatedConsumptionKwh: readings[endOfHalfHourISO].estimatedConsumptionKwh + consumptionKwh,
      };
    } else if (readingDate <= hourMidpoint) {
      readings[endOfHalfHourISO] = {
        readingEndTimeLocal: endOfHalfHourISO,
        deliveredKwh,
        consumptionKwh,
        estimatedConsumptionKwh: consumptionKwh,
      };
    }
  });
  return Object.keys(readings).map(dateISO => readings[dateISO]);
};
